import React from 'react';
import { Link } from 'react-router-dom';

const links: { to: string; label: string }[] = [
  { to: '/admin/email-verification', label: 'Email verification' },
  { to: '/admin/stylist-approval', label: 'Stylist approval' },
  { to: '/admin/support', label: 'Support chat' },
  { to: '/admin/disputes', label: 'Disputes' },
  { to: '/admin/quick-user-search', label: 'Quick user search' },
  { to: '/admin/system-health', label: 'Unsettled Stripe fees (system health)' },
];

const AdminActionCenterPage: React.FC = () => (
  <div style={{ padding: 24, maxWidth: 720 }}>
    <h1 style={{ marginBottom: 16 }}>Action center</h1>
    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
      {links.map((l) => (
        <li key={l.to} style={{ marginBottom: 12 }}>
          <Link
            to={l.to}
            style={{
              display: 'block',
              padding: 14,
              borderRadius: 10,
              border: '1px solid #eee',
              background: '#fff',
              textDecoration: 'none',
              color: '#C9A84C',
              fontWeight: 600,
            }}>
            {l.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export default AdminActionCenterPage;
